<script lang="ts">
    import OneNumber from './OneNumber.svelte';

    export let daysOfMonth: number[] = [];
    export let onChange: (daysOfWeek: number[]) => void;
    export let disabled: boolean = false;

    // from 1 to 31
    let availableDaysOfMonth = Array.from({ length: 31 }, (_, i) => i + 1);
</script>

<div class="days-of-week-container">
    {#each availableDaysOfMonth as day}
        <OneNumber
            value={day}
            title={day}
            isSelected={daysOfMonth.includes(day)}
            {disabled}
            onChange={() => {
                if (daysOfMonth.includes(day)) {
                    onChange(daysOfMonth.filter(d => d !== day));
                } else {
                    onChange([...daysOfMonth, day]);
                }
            }}
        />
    {/each}
</div>

<style>
    .days-of-week-container {
        display: flex;
        flex-wrap: wrap;
        column-gap: 2px;
        row-gap: 2px;
    }
</style>
